import { BoxControl } from "@wordpress/components";

export default function SpaceControl({
    containerClass,
    value,
    onChange,
    ...props
}) {
    // Normalize current value shape
    const current = value || {
        top: "",
        right: "",
        bottom: "",
        left: "",
    };

    return (
        <div className={containerClass}>
            <BoxControl
                __next40pxDefaultSize
                label=""
                values={current}
                onChange={onChange}
                {...props}
            />
        </div>
    );
}
